export const MAIN_SCROLL_CONTAINER_SELECTOR = '[data-scroll-container]' as const

export function getMainScrollContainer(): HTMLElement | null {
  if (typeof document === 'undefined') return null
  return document.querySelector<HTMLElement>(MAIN_SCROLL_CONTAINER_SELECTOR)
}

export function getMainScrollTop(): number {
  return getMainScrollContainer()?.scrollTop ?? 0
}

export function isMainScrollAtTop(threshold = 0): boolean {
  return getMainScrollTop() <= threshold
}

export function scrollMainTo(top: number, options?: Omit<ScrollToOptions, 'top'>): void {
  getMainScrollContainer()?.scrollTo({ top, ...options })
}

export function scrollMainToTop(options?: Omit<ScrollToOptions, 'top'>): void {
  scrollMainTo(0, options)
}
